import { render, staticRenderFns } from "./PriceHindware.vue?vue&type=template&id=79e1210c&scoped=true"
import script from "./PriceHindware.vue?vue&type=script&lang=js"
export * from "./PriceHindware.vue?vue&type=script&lang=js"
import style0 from "./PriceHindware.vue?vue&type=style&index=0&id=79e1210c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1210c",
  null
  
)

export default component.exports